import React from "react";
import "./style.scss";
import eye from "../../img/eye.svg";
import eyeOff from "../../img/eye-off.svg";

const Input = ({
  typeInput,
  onClick,
  pas,
  onChange,
  placeholder,
  value,
  autoComplete,
  name,
  error,
  onBlur,
  onFocus,
}) => {
  return (
    <>
      {typeInput === "text" && (
        <input
          type="text"
          placeholder={placeholder}
          onInput={(e) => onChange(e)}
          value={value}
          autoComplete={autoComplete ? autoComplete : "off"}
          name={name}
          className={error ? "error" : ""}
          onBlur={onBlur}
          onFocus={onFocus}
        />
      )}
      {typeInput === "password" && (
        <div className={"password-input-wrapper"}>
          <input
            placeholder={placeholder}
            type={pas ? "password" : "text"}
            onInput={(e) => onChange(e)}
            autoComplete="new-password"
            name="password"
            className={error ? "error" : ""}
            onBlur={onBlur}
            onFocus={onFocus}
            value={value}
          />
          <div className={"password-img"} onClick={() => onClick()}>
            <img src={pas ? eyeOff : eye} alt="eye-password" />
          </div>
        </div>
      )}
    </>
  );
};

export default Input;
